var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: { "main-content": !_vm.invoiceId },
      on: { click: _vm.closeCalendar },
    },
    [
      !_vm.invoiceId
        ? _c("Breadcrumbs", { attrs: { breadcrumbs: _vm.breadcrumbs } })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12 text-center" }, [
          _vm.loading
            ? _c(
                "div",
                { staticClass: "loading_div" },
                [
                  _c("pulse-loader", {
                    staticClass: "text-center",
                    attrs: { loading: _vm.loading, color: _vm.color },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.exportModalData
        ? _c(
            "EmptyCardModal",
            {
              attrs: {
                modalData: _vm.exportModalData,
                onModalClose: () => (_vm.exportModalData = null),
                onModalAccept: () => _vm.exportXls(),
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _c(
                    "div",
                    [
                      _c("ExcelExportOptions", {
                        ref: "exportExcelOptions",
                        attrs: {
                          extraOptions: {
                            priceQtyRate: true,
                            showDetailsExpireDates: true,
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modalData
        ? _c(
            "EmptyCardModal",
            {
              ref: "deleteConfirmModal",
              attrs: {
                modalData: _vm.modalData,
                onModalClose: () => (_vm.modalData = null),
                onModalAccept: () => _vm.acceptModal(),
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _c("div", { staticClass: "half_center" }, [
                    _c("p", [_vm._v(_vm._s(_vm.modalData.body))]),
                    _vm._v(" "),
                    _vm.modalData.confirmCode
                      ? _c("div", [
                          _c("h4", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.modalData.confirmCode)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [
                              _vm._v("Введите код для подтверждения действия"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.modalData.confirmCodeInput,
                                  expression: "modalData.confirmCodeInput",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: {
                                value: _vm.modalData.confirmCodeInput,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.modalData,
                                    "confirmCodeInput",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm.invoice
          ? _c("div", { staticClass: "col-md-12 header_sticky" }, [
              _c("div", { staticClass: "card invoice_header" }, [
                _c(
                  "div",
                  { staticClass: "card-header flex justify-content-between" },
                  [
                    _c("h5", { staticClass: "flex-grow-1" }, [
                      _vm._v("\n            Накладная "),
                      _c("strong", [_vm._v(_vm._s(_vm.invoice.id))]),
                      _vm._v(" " + _vm._s(_vm.printType()) + "\n          "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        on: {
                          click: function ($event) {
                            _vm.showHeader = !_vm.showHeader
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.showHeader ? "Скрыть" : "Показать") +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.showHeader
                  ? _c("div", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-12 mb-1" }, [
                          _c(
                            "div",
                            { staticClass: "flex justify-content-between" },
                            [
                              _c("div", { staticClass: "flex" }, [
                                _vm.invoice.store_out
                                  ? _c("div", [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("Отправитель:"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          staticClass: "form-control",
                                          attrs: { disabled: "true" },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.stores[
                                                    _vm.invoice.store_out
                                                  ]
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", [
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v("Получатель:"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      staticClass: "form-control",
                                      attrs: { disabled: true },
                                    },
                                    [
                                      _c("option", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.stores[_vm.invoice.store_in]
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.invoiceType === "income" ||
                                _vm.invoiceType === "order"
                                  ? _c("div", [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("Валюта:"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          staticClass: "form-control",
                                          attrs: { disabled: true },
                                        },
                                        [
                                          _c("option", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencies[
                                                  _vm.invoice.currency_id
                                                ]
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Дата накладной:"),
                                    ]),
                                    _vm._v(" "),
                                    _c("DateSelect", {
                                      ref: "selectedDateComponent",
                                      attrs: {
                                        disabled: true,
                                        disableEdit:
                                          !_vm.allowToEdit &&
                                          !_vm.allowToChangeTheDate,
                                        useDisabledDates: false,
                                        selectedDate: _vm.deliveryDate,
                                        onSelect: (date) =>
                                          (this.deliveryDate = date),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "big-badge" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Статус:"),
                                    ]),
                                    _vm._v(" "),
                                    _c("invoiceStatus", {
                                      attrs: { invoice: _vm.invoice },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "flex flex_gap_5" }, [
                                _vm.invoice.type === 1
                                  ? _c("div", [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("Поставщик"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.invoice.supplier_id,
                                              expression: "invoice.supplier_id",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.invoice,
                                                "supplier_id",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "0" } },
                                            [_vm._v("Без поставщика")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.suppliers,
                                            function (supplier) {
                                              return _c(
                                                "option",
                                                {
                                                  domProps: {
                                                    value: supplier.id,
                                                  },
                                                },
                                                [_vm._v(_vm._s(supplier.title))]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isAllowToShowExpireDates()
                                  ? _c("div", [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("Сроки годности препаратов"),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "text-right" }, [
                                        _vm.isInvoiceHasExpireDates()
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "btn btn-info",
                                                on: {
                                                  click:
                                                    _vm.actionShowExpireDates,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.showExpireDates
                                                        ? "Скрыть"
                                                        : "Показать"
                                                    ) +
                                                    "\n                      "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.isInvoiceHasExpireDates()
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "btn btn-info",
                                                on: {
                                                  click:
                                                    _vm.actionShowExpireDates,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.showExpireDates
                                                        ? "Скрыть"
                                                        : "Редактировать"
                                                    ) +
                                                    "\n                      "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group flex mb-1" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.invoice.use_for_autolist,
                                  expression: "invoice.use_for_autolist",
                                },
                              ],
                              staticClass: "mr-1",
                              attrs: { type: "checkbox", id: "ch_opt_1" },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.invoice.use_for_autolist
                                )
                                  ? _vm._i(_vm.invoice.use_for_autolist, null) >
                                    -1
                                  : _vm.invoice.use_for_autolist,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.invoice.use_for_autolist,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.invoice,
                                          "use_for_autolist",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.invoice,
                                          "use_for_autolist",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.invoice,
                                      "use_for_autolist",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label pointer",
                                attrs: { for: "ch_opt_1" },
                              },
                              [
                                _vm._v(
                                  "Учитывать в резерве для всех статусов\n                  (автосписок)"
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group mb-1" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Трэк номер"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.invoice.track,
                                    expression: "invoice.track",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text", placeholder: "ТТН..." },
                                domProps: { value: _vm.invoice.track },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.invoice,
                                      "track",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.invoice.track
                                ? _c(
                                    "div",
                                    { staticClass: "input-group-append" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-info",
                                          attrs: { type: "button" },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "text-decoration-none text-white",
                                              attrs: {
                                                href: `https://flippost.com/instruments/online/?number=${_vm.invoice.track}`,
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-info",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Комментарий:"),
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.invoice.comment,
                                expression: "invoice.comment",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { rows: "2" },
                            domProps: { value: _vm.invoice.comment },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.invoice,
                                  "comment",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _vm.invoiceType === "income"
                          ? _c(
                              "div",
                              { staticClass: "col-md-6" },
                              [
                                _c("InvoiceDiscount", {
                                  attrs: { invoice: _vm.invoice },
                                }),
                                _vm._v(" "),
                                _vm.invoice.supplier
                                  ? _c("DeliveryVolumeCalculation", {
                                      attrs: {
                                        supplier: _vm.invoice.supplier,
                                        details: _vm.invoice.details,
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.invoice.type === 1
                                  ? _c("div", { staticClass: "mt-1" }, [
                                      _c(
                                        "div",
                                        { staticClass: "form-group mb-0" },
                                        [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.invoicesExpDatesConfirmed,
                                                  expression:
                                                    "invoicesExpDatesConfirmed",
                                                },
                                              ],
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.invoicesExpDatesConfirmed
                                                )
                                                  ? _vm._i(
                                                      _vm.invoicesExpDatesConfirmed,
                                                      null
                                                    ) > -1
                                                  : _vm.invoicesExpDatesConfirmed,
                                              },
                                              on: {
                                                change: [
                                                  function ($event) {
                                                    var $$a =
                                                        _vm.invoicesExpDatesConfirmed,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.invoicesExpDatesConfirmed =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.invoicesExpDatesConfirmed =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _vm.invoicesExpDatesConfirmed =
                                                        $$c
                                                    }
                                                  },
                                                  function ($event) {
                                                    return _vm.updateInvoiceDetail(
                                                      "expDatesConfirmed"
                                                    )
                                                  },
                                                ],
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v("сроки внесены!"),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.invoicesDrugsConfirmed,
                                                expression:
                                                  "invoicesDrugsConfirmed",
                                              },
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.invoicesDrugsConfirmed
                                              )
                                                ? _vm._i(
                                                    _vm.invoicesDrugsConfirmed,
                                                    null
                                                  ) > -1
                                                : _vm.invoicesDrugsConfirmed,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a =
                                                      _vm.invoicesDrugsConfirmed,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.invoicesDrugsConfirmed =
                                                          $$a.concat([$$v]))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.invoicesDrugsConfirmed =
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                    }
                                                  } else {
                                                    _vm.invoicesDrugsConfirmed =
                                                      $$c
                                                  }
                                                },
                                                function ($event) {
                                                  return _vm.updateInvoiceDetail(
                                                    "drugConfirmStatus"
                                                  )
                                                },
                                              ],
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v("товар сверен!"),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.invoicesDrugsConfirmedUser,
                                                expression:
                                                  "invoicesDrugsConfirmedUser",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.invoicesDrugsConfirmedUser =
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                },
                                                function ($event) {
                                                  return _vm.updateInvoiceDetail(
                                                    "drugConfirmStatus"
                                                  )
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "0",
                                                  disabled: "",
                                                },
                                              },
                                              [_vm._v("Выберите пользователя")]
                                            ),
                                            _vm._v(" "),
                                            _c("option", [_vm._v("АИ")]),
                                            _vm._v(" "),
                                            _c("option", [_vm._v("ОА")]),
                                            _vm._v(" "),
                                            _c("option", [_vm._v("МА")]),
                                          ]
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm.invoice.under_cost_calculation
                        ? _c(
                            "div",
                            { staticClass: "alert alert-warning mt-1" },
                            [
                              _c("p", [
                                _vm._v(
                                  "Заявка на фоновом обновлении, если хотите изменить заявку, дождитесь окончания фоновой задачи"
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.generalAllowEdit
                        ? _c("div", { staticClass: "pt-1" }, [
                            _vm.invoice.status !== 0
                              ? _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-6" },
                                    [
                                      _c("StatusSubStatusSelect", {
                                        attrs: {
                                          invoice: _vm.invoice,
                                          onStatusChange: (status) => {
                                            this.newStatus = status
                                            this.updateDeliveryDateLimits()
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.allowToCreateEditInvoices
                                    ? _c(
                                        "div",
                                        { staticClass: "col-md-6 text-right" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-outline-info btn-sm mr-2",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.exportXls(false)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "Экспортировать в XLS\n                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.invoice.status == 1
                                            ? _c(
                                                "vue-ladda",
                                                {
                                                  attrs: {
                                                    "button-class":
                                                      "btn btn-danger ladda-button",
                                                    "data-style": "zoom-in",
                                                    loading:
                                                      _vm.btnUpdateLoading,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.confirmDelete()
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Удалить\n                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          +_vm.invoice.status === 3
                                            ? [
                                                _c(
                                                  "vue-ladda",
                                                  {
                                                    attrs: {
                                                      "button-class":
                                                        "btn btn-outline-success ladda-button",
                                                      "data-style": "zoom-in",
                                                      loading:
                                                        _vm.btnUpdateLoading,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.updateInvoice(
                                                          "update"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Сохранить\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "vue-ladda",
                                                  {
                                                    attrs: {
                                                      "button-class":
                                                        "btn btn-success ladda-button",
                                                      "data-style": "zoom-in",
                                                      loading:
                                                        _vm.btnUpdateLoading,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.updateInvoice(
                                                          "update",
                                                          true
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Перевести накладную в дорогу\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : [
                                                +_vm.invoice.status === 6
                                                  ? _c("LoadingButton", {
                                                      attrs: {
                                                        title:
                                                          "Вернуть на приемку",
                                                        type: "button",
                                                        loading:
                                                          _vm.btnUpdateLoading,
                                                        color:
                                                          _vm.$constants
                                                            .WARNING_COLOR,
                                                        onClick: () =>
                                                          _vm.confirmDelete(
                                                            true
                                                          ),
                                                        className:
                                                          "btn btn-outline-warning ",
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "vue-ladda",
                                                  {
                                                    attrs: {
                                                      "button-class":
                                                        "btn btn-success ladda-button",
                                                      "data-style": "zoom-in",
                                                      loading:
                                                        _vm.btnUpdateLoading,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.updateInvoice(
                                                          "update"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Сохранить\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ])
                              : _c(
                                  "div",
                                  { staticClass: "row" },
                                  [
                                    _vm.allowActionButtons &&
                                    _vm.allowToCreateEditInvoices
                                      ? [
                                          _vm.invoice.type === 1 &&
                                          _vm.transitStores
                                            ? _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex" },
                                                    [
                                                      _c("div", [
                                                        _c(
                                                          "select",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.transitStoreId,
                                                                expression:
                                                                  "transitStoreId",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                var $$selectedVal =
                                                                  Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                _vm.transitStoreId =
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                              },
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.transitStores,
                                                            function (
                                                              store,
                                                              id
                                                            ) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  domProps: {
                                                                    value: id,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      store
                                                                    ) +
                                                                      "\n                        "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "vue-ladda",
                                                            {
                                                              attrs: {
                                                                "button-class":
                                                                  "btn btn-success",
                                                                disabled:
                                                                  !_vm.isAllowToTransit,
                                                                "data-style":
                                                                  "zoom-in",
                                                                loading:
                                                                  _vm.btnUpdateLoading,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.createTransitInvoice()
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Создать перемещение\n                      "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.invoice.based_invoice
                                                    ? _c(
                                                        "div",
                                                        { staticClass: "mt-2" },
                                                        [
                                                          _vm._v(
                                                            "\n                    Создана накладная "
                                                          ),
                                                          _c("strong", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.invoice
                                                                  .based_invoice
                                                                  .id
                                                              )
                                                            ),
                                                          ]),
                                                          _vm._v(
                                                            " на основе текущей\n                    "
                                                          ),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-xs btn-success ml-1",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.openBasedInvoice(
                                                                      _vm
                                                                        .invoice
                                                                        .based_invoice
                                                                        .id
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      Показать\n                    "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-xs btn-success newWindowBtn",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.openInNewPage(
                                                                      "InvoicesEdit",
                                                                      {
                                                                        id: _vm
                                                                          .invoice
                                                                          .based_invoice
                                                                          .id,
                                                                      }
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "icon-fa icon-fa-external-link",
                                                              }),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.basedInvoiceChanges
                                                            ? [
                                                                _c(
                                                                  "v-popover",
                                                                  {
                                                                    staticClass:
                                                                      "d-inline",
                                                                    attrs: {
                                                                      placement:
                                                                        "bottom",
                                                                      trigger:
                                                                        "hover",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "pointer badge badge-info",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Изменения в накладной"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "template",
                                                                      {
                                                                        slot: "popover",
                                                                      },
                                                                      _vm._l(
                                                                        _vm.basedInvoiceChanges,
                                                                        function (
                                                                          block,
                                                                          blockName
                                                                        ) {
                                                                          return _c(
                                                                            "div",
                                                                            [
                                                                              _c(
                                                                                "label",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      for: "",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm
                                                                                        .changesBlockNames[
                                                                                        blockName
                                                                                      ]
                                                                                    ) +
                                                                                      ":"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _vm._l(
                                                                                block,
                                                                                function (
                                                                                  record
                                                                                ) {
                                                                                  return _c(
                                                                                    "p",
                                                                                    [
                                                                                      blockName ===
                                                                                      "deleted"
                                                                                        ? [
                                                                                            _vm._v(
                                                                                              "\n                                " +
                                                                                                _vm._s(
                                                                                                  record
                                                                                                    .drug
                                                                                                    .title
                                                                                                ) +
                                                                                                " (" +
                                                                                                _vm._s(
                                                                                                  record.qty
                                                                                                ) +
                                                                                                ")\n                              "
                                                                                            ),
                                                                                          ]
                                                                                        : [
                                                                                            _vm._v(
                                                                                              "\n                                " +
                                                                                                _vm._s(
                                                                                                  record
                                                                                                    .drug
                                                                                                    .title
                                                                                                ) +
                                                                                                " - " +
                                                                                                _vm._s(
                                                                                                  record.qty
                                                                                                ) +
                                                                                                "\n                                "
                                                                                            ),
                                                                                            record.oldQty
                                                                                              ? _c(
                                                                                                  "span",
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "(старое количество: " +
                                                                                                        _vm._s(
                                                                                                          record.oldQty
                                                                                                        ) +
                                                                                                        ")"
                                                                                                    ),
                                                                                                  ]
                                                                                                )
                                                                                              : _vm._e(),
                                                                                          ],
                                                                                    ],
                                                                                    2
                                                                                  )
                                                                                }
                                                                              ),
                                                                            ],
                                                                            2
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    ),
                                                                  ],
                                                                  2
                                                                ),
                                                              ]
                                                            : [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "badge badge-success",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "совпадает на 100%"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                        ],
                                                        2
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("hr"),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-6" },
                                            [
                                              _c(
                                                "vue-ladda",
                                                {
                                                  attrs: {
                                                    "button-class":
                                                      "btn btn-primary",
                                                    "data-style": "zoom-in",
                                                    loading:
                                                      _vm.btnUpdateLoading,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.updateInvoice(
                                                        "reset"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Отказаться от проведения\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-6 text-right",
                                            },
                                            [
                                              _vm.invoiceType === "income"
                                                ? _c("div")
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-outline-info btn-sm mr-2",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.exportXls(
                                                        false
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Экспортировать в XLS\n                  "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "vue-ladda",
                                                {
                                                  attrs: {
                                                    "button-class":
                                                      "btn btn-success ladda-button",
                                                    "data-style": "zoom-in",
                                                    loading:
                                                      _vm.btnUpdateLoading,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.updateInvoice()
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Сохранить\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.invoice.status === 7
                        ? _c("div", { staticClass: "pt-1" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateInvoiceData(
                                      "updateStatus",
                                      { newStatus: 5 }
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Остановить приемку (только ПОСЛЕ согласования со складом)\n            "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.invoice.based_id
                        ? _c(
                            "div",
                            { staticClass: "mt-2" },
                            [
                              _vm._v(
                                "\n            Накладная создана на основе накладной поступления:\n            "
                              ),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.invoice.based_id)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-xs btn-success ml-1",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openBasedInvoice(
                                        _vm.invoice.based_id
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Показать\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-xs btn-success newWindowBtn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openInNewPage("InvoicesEdit", {
                                        id: _vm.invoice.based_id,
                                      })
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "icon-fa icon-fa-external-link",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.basedInvoiceChanges
                                ? [
                                    _c(
                                      "v-popover",
                                      {
                                        staticClass: "d-inline",
                                        attrs: {
                                          placement: "bottom",
                                          trigger: "hover",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pointer badge badge-info",
                                          },
                                          [_vm._v("Изменения в накладной")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "template",
                                          { slot: "popover" },
                                          _vm._l(
                                            _vm.basedInvoiceChanges,
                                            function (block, blockName) {
                                              return _c(
                                                "div",
                                                [
                                                  _c(
                                                    "label",
                                                    { attrs: { for: "" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.changesBlockNames[
                                                            blockName
                                                          ]
                                                        ) + ":"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    block,
                                                    function (record) {
                                                      return _c(
                                                        "p",
                                                        [
                                                          blockName ===
                                                          "deleted"
                                                            ? [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      record
                                                                        .drug
                                                                        .title
                                                                    ) +
                                                                    " (" +
                                                                    _vm._s(
                                                                      record.qty
                                                                    ) +
                                                                    ")\n                      "
                                                                ),
                                                              ]
                                                            : [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      record
                                                                        .drug
                                                                        .title
                                                                    ) +
                                                                    " - " +
                                                                    _vm._s(
                                                                      record.qty
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                                record.oldQty
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        "(старое количество: " +
                                                                          _vm._s(
                                                                            record.oldQty
                                                                          ) +
                                                                          ")"
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                              ],
                                                        ],
                                                        2
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                : [
                                    _c(
                                      "span",
                                      { staticClass: "badge badge-success" },
                                      [_vm._v("совпадает на 100%")]
                                    ),
                                  ],
                            ],
                            2
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.invoice
          ? _c("div", { staticClass: "col-md-12" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body details_card" }, [
                  _c(
                    "div",
                    [
                      _vm.invoice.status === 6
                        ? [
                            _c("DetailsOnModerations", {
                              ref: "invoiceDetails",
                              attrs: {
                                invoice: _vm.invoice,
                                records: _vm.invoice.details,
                                updateRecords: (d) => (_vm.invoice.details = d),
                              },
                            }),
                          ]
                        : [
                            _c("OrderInvoiceDetails", {
                              ref: "invoiceDetails",
                              attrs: {
                                invoice: _vm.invoice,
                                storeData: _vm.storeData,
                                showExpireDates: _vm.showExpireDates,
                                editQtyByFact: false,
                                records: _vm.invoice.details,
                                updateRecords: (d) => (_vm.invoice.details = d),
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  !_vm.btnUpdateLoading
                    ? _c(
                        "div",
                        [
                          _c("UploadImages", {
                            ref: "files",
                            attrs: {
                              smallPhotos: true,
                              files: _vm.uploadedFiles,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "div",
                    { staticClass: "overflow-auto" },
                    [
                      _vm.invoice
                        ? _c("invoiceTrace", {
                            attrs: {
                              traceActions: _vm.traceActions,
                              traceDrugs: _vm.traceDrugs,
                              invoiceType:
                                _vm.invoice.type === 2 ? "transit" : "income",
                              users: _vm.traceUsers,
                              trace: _vm.invoice.trace,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }